import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationsTable from './components/Table/NotificationsTable';
import NotificationForm from './components/Form/Notification.Form';
import './style.scss';

const Notifications: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="notifications">
      <span className="notifications-text">{t('components:notifications.helperText')}</span>
      <NotificationForm />
      <NotificationsTable />
    </div>
  );
};

export default Notifications;
